import React from 'react';

/**
 * Thin progress bar with percentage label (Projects table).
 */
const ProgressBar = ({ value = 0, className = '' }) => {
  const pct = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  return (
    <div className={`flex items-center gap-3 min-w-[120px] ${className}`}>
      <div className="flex-1 h-1.5 rounded-full bg-secondary-100 dark:bg-secondary-700 overflow-hidden">
        <div
          className="h-full rounded-full bg-primary-600 transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs font-medium text-secondary-600 dark:text-secondary-300 w-8 text-right tabular-nums">
        {pct}%
      </span>
    </div>
  );
};

export default ProgressBar;
